// **  Initial State
const initialState = {
    allData: [],
    selected: null,
    image: null
}

const sliderReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SLIDER':
            return { ...state, allData: action.data }
        case 'ADD_SLIDER':
            return { ...state, allData:[...state.allData.concat(action.data)]  }
        case 'SELECTED_SLIDER':
            return { ...state, selected: action.data }
        case 'UPDATE_SLIDER':
            return {
                ...state,
                allData: [
                    ...state.allData.filter(category => category.id !== action.data.id),
                    action.data
                ]
            }
        case 'DELETE_SLIDER':
            return {
                ...state,
                allData: state.allData.filter(category => {return category.id !== action.data.deleteitems} )
            }
        default:
            return state
    }
}

export default sliderReducer
